// ChooseNavigator.jsx
const ChooseNavigator = ({ onClose, startPoint, endPoint, onUseEmbedded }) => {
    // Функция для открытия Google Maps
    const openGoogleMaps = () => {
        if (!startPoint || !endPoint) return;

        const url = `https://www.google.com/maps/dir/?api=1&origin=${startPoint.lat},${startPoint.lng}&destination=${endPoint.lat},${endPoint.lng}&travelmode=walking`;
        window.open(url, '_blank');
        onClose();
    };

    // Функция для открытия Яндекс Карт
    const openYandexMaps = () => {
        if (!startPoint || !endPoint) return;

        // Мобильное приложение Яндекс Навигатор
        const yandexUrl = `yandexnavi://build_route_on_map?lat_to=${endPoint.lat}&lon_to=${endPoint.lng}&lat_from=${startPoint.lat}&lon_from=${startPoint.lng}`;

        // Web версия Яндекс Карт (запасной вариант)
        const webUrl = `https://yandex.ru/maps/?rtext=${startPoint.lat},${startPoint.lng}~${endPoint.lat},${endPoint.lng}&rtt=auto`;

        // Пробуем открыть приложение, если не получится - открываем веб-версию
        window.location.href = yandexUrl;

        // Даем короткую задержку и проверяем, открылось ли приложение
        setTimeout(() => {
            window.open(webUrl, '_blank');
        }, 500);

        onClose();
    };

    return (
        <div className="container">
            <div className="container__header" style={{margin: '0', padding: '0'}}>
                <h2 style={{marginTop: '0px', marginBottom: '16px'}}>
                    Выберите навигатор
                </h2>
            </div>
            <div className="choose-navigator__items">
                <button
                    className="card__footer-route card__footer-route-unselected"
                    onClick={() => {
                        openGoogleMaps();
                        onClose();
                    }}
                >
                    Google Maps
                </button>
                <button
                    className="card__footer-route card__footer-route-unselected"
                    onClick={() => {
                        openYandexMaps();
                        onClose();
                    }}
                >
                    Yandex Maps
                </button>
                <button className="card__footer-route" onClick={() => {
                    onUseEmbedded();
                }}
                >
                    Встроенный
                </button>
            </div>
        </div>
    )
};

export default ChooseNavigator;